export default function PageLoading() {
  return (
    <div
      className="min-h-[40vh] flex items-center justify-center"
      aria-label="Loading page"
      role="status"
    >
      <div
        className="h-10 w-10 rounded-full border-2 border-brand-mint/30 border-t-brand-mint animate-spin"
        aria-hidden
      />
    </div>
  );
}
